function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function cov_kytgi2cln() {
  var path = "/app/src/components/learn-more-with-schedule/learn-more-with-schedule.tsx";
  var hash = "4887d4fefce5e35f7104843c2e7e105799aafe99";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/learn-more-with-schedule/learn-more-with-schedule.tsx",
    statementMap: {
      "0": {
        start: {
          line: 28,
          column: 37
        },
        end: {
          line: 184,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 21
        }
      },
      "2": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 51
        }
      },
      "3": {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 23
        }
      },
      "4": {
        start: {
          line: 40,
          column: 35
        },
        end: {
          line: 40,
          column: 64
        }
      },
      "5": {
        start: {
          line: 42,
          column: 23
        },
        end: {
          line: 42,
          column: 58
        }
      },
      "6": {
        start: {
          line: 43,
          column: 33
        },
        end: {
          line: 43,
          column: 55
        }
      },
      "7": {
        start: {
          line: 45,
          column: 21
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "8": {
        start: {
          line: 49,
          column: 26
        },
        end: {
          line: 49,
          column: 48
        }
      },
      "9": {
        start: {
          line: 50,
          column: 31
        },
        end: {
          line: 50,
          column: 47
        }
      },
      "10": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 59,
          column: 62
        }
      },
      "11": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 58,
          column: 7
        }
      },
      "12": {
        start: {
          line: 57,
          column: 24
        },
        end: {
          line: 57,
          column: 51
        }
      },
      "13": {
        start: {
          line: 61,
          column: 20
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "14": {
        start: {
          line: 67,
          column: 19
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "15": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 18
        }
      },
      "16": {
        start: {
          line: 71,
          column: 31
        },
        end: {
          line: 71,
          column: 77
        }
      },
      "17": {
        start: {
          line: 72,
          column: 16
        },
        end: {
          line: 74,
          column: 34
        }
      },
      "18": {
        start: {
          line: 76,
          column: 16
        },
        end: {
          line: 76,
          column: 39
        }
      },
      "19": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 183,
          column: 4
        }
      },
      "20": {
        start: {
          line: 119,
          column: 32
        },
        end: {
          line: 119,
          column: 64
        }
      },
      "21": {
        start: {
          line: 142,
          column: 30
        },
        end: {
          line: 142,
          column: 62
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 37
          },
          end: {
            line: 28,
            column: 38
          }
        },
        loc: {
          start: {
            line: 28,
            column: 73
          },
          end: {
            line: 184,
            column: 1
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 13
          }
        },
        loc: {
          start: {
            line: 52,
            column: 18
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 57,
            column: 13
          },
          end: {
            line: 57,
            column: 14
          }
        },
        loc: {
          start: {
            line: 57,
            column: 24
          },
          end: {
            line: 57,
            column: 51
          }
        },
        line: 57
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 67,
            column: 19
          },
          end: {
            line: 67,
            column: 20
          }
        },
        loc: {
          start: {
            line: 67,
            column: 36
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 67
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 119,
            column: 26
          },
          end: {
            line: 119,
            column: 27
          }
        },
        loc: {
          start: {
            line: 119,
            column: 32
          },
          end: {
            line: 119,
            column: 64
          }
        },
        line: 119
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 142,
            column: 24
          },
          end: {
            line: 142,
            column: 25
          }
        },
        loc: {
          start: {
            line: 142,
            column: 30
          },
          end: {
            line: 142,
            column: 62
          }
        },
        line: 142
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 29
          }
        }, {
          start: {
            line: 42,
            column: 33
          },
          end: {
            line: 42,
            column: 46
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 31
          },
          end: {
            line: 71,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 61
          },
          end: {
            line: 71,
            column: 69
          }
        }, {
          start: {
            line: 71,
            column: 72
          },
          end: {
            line: 71,
            column: 77
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 31
          },
          end: {
            line: 71,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 31
          },
          end: {
            line: 71,
            column: 39
          }
        }, {
          start: {
            line: 71,
            column: 43
          },
          end: {
            line: 71,
            column: 58
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 74,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 73,
            column: 24
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 34
          }
        }],
        line: 72
      },
      "4": {
        loc: {
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 100,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 29
          }
        }, {
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 99,
            column: 12
          }
        }],
        line: 93
      },
      "5": {
        loc: {
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 124,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 9
          },
          end: {
            line: 102,
            column: 26
          }
        }, {
          start: {
            line: 103,
            column: 10
          },
          end: {
            line: 123,
            column: 12
          }
        }],
        line: 102
      },
      "6": {
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 133,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 16
          },
          end: {
            line: 132,
            column: 57
          }
        }, {
          start: {
            line: 133,
            column: 16
          },
          end: {
            line: 133,
            column: 51
          }
        }],
        line: 131
      },
      "7": {
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 29
          }
        }, {
          start: {
            line: 131,
            column: 33
          },
          end: {
            line: 131,
            column: 38
          }
        }],
        line: 131
      },
      "8": {
        loc: {
          start: {
            line: 154,
            column: 7
          },
          end: {
            line: 167,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 155,
            column: 8
          },
          end: {
            line: 160,
            column: 10
          }
        }, {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 166,
            column: 10
          }
        }],
        line: 154
      },
      "9": {
        loc: {
          start: {
            line: 175,
            column: 7
          },
          end: {
            line: 179,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 7
          },
          end: {
            line: 175,
            column: 17
          }
        }, {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 178,
            column: 17
          }
        }],
        line: 175
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4887d4fefce5e35f7104843c2e7e105799aafe99"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kytgi2cln = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_kytgi2cln();
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { CreditCards } from 'src/components/credit-cards';
import { Currency } from 'src/components/currency';
import { InstallmentsInput } from 'src/components/installments-input';
import { LearnMoreHowItWorks } from 'src/components/learn-more-how-it-works';
import { InstallmentItem } from 'src/components/long-term-content/components/installment-item';
import { PayNextMonthTab } from 'src/components/pay-next-month-tab';
import { PopupLearnMoreBackgroundHeader } from 'src/components/popup-learn-more-background-header';
import { TrustBanner } from 'src/components/trust-banner';
import { Button } from 'src/components/v2/button';
import { ACTIONS } from 'src/constants/common';
import { COUNTRY_BY_CURRENCY_MAP } from 'src/constants/country-by-currency-map';
import { INITIAL_PRICE, INSTALLMENT_PLANS } from 'src/constants/learn-more';
import { useAppContext } from 'src/context/store/app-provider';
import { useLocale } from 'src/hooks/use-locale';
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
import { getPriceSplitOf } from 'src/utils/get-price-split-of';
import { useGetPaymentScheduleTitles } from 'src/utils/use-get-payment-schedule-titles';
import styles from './styles.css';
cov_kytgi2cln().s[0]++;
export var LearnMoreWithSchedule = function LearnMoreWithSchedule(_ref) {
  var onClose = _ref.onClose,
    onContinue = _ref.onContinue;
  cov_kytgi2cln().f[0]++;
  var _ref2 = (cov_kytgi2cln().s[1]++, useAppContext()),
    price = _ref2.price,
    priceRaw = _ref2.priceRaw,
    _currency = _ref2.currency,
    installmentsCount = _ref2.installmentsCount,
    dispatch = _ref2.dispatch,
    partnerCharges = _ref2.partnerCharges;
  var country = (cov_kytgi2cln().s[2]++, COUNTRY_BY_CURRENCY_MAP[_currency]);
  var t = (cov_kytgi2cln().s[3]++, useLocale());
  var getPaymentScheduleTitles = (cov_kytgi2cln().s[4]++, useGetPaymentScheduleTitles());
  var initialValue = (cov_kytgi2cln().s[5]++, ((cov_kytgi2cln().b[0][0]++, price) || (cov_kytgi2cln().b[0][1]++, INITIAL_PRICE)).toString());
  var _ref3 = (cov_kytgi2cln().s[6]++, useState(initialValue)),
    _ref4 = _slicedToArray(_ref3, 2),
    inputValue = _ref4[0],
    setValue = _ref4[1];
  var checkPrice = (cov_kytgi2cln().s[7]++, createNormalizeCheckingNumber('Price argument is not a number', 0));
  var isRawPriceValid = (cov_kytgi2cln().s[8]++, !!checkPrice(priceRaw));
  var isCalculationEnabled = (cov_kytgi2cln().s[9]++, !isRawPriceValid);
  cov_kytgi2cln().s[10]++;
  useEffect(function () {
    cov_kytgi2cln().f[1]++;
    cov_kytgi2cln().s[11]++;
    dispatch({
      type: ACTIONS.SET_TITLES,
      payload: new Array(installmentsCount).fill(null).map(function (_n, i) {
        cov_kytgi2cln().f[2]++;
        cov_kytgi2cln().s[12]++;
        return getPaymentScheduleTitles(i);
      })
    });
  }, [dispatch, getPaymentScheduleTitles, installmentsCount]);
  var pricePart = (cov_kytgi2cln().s[13]++, getPriceSplitOf(Number(inputValue), _currency, installmentsCount));
  cov_kytgi2cln().s[14]++;
  var onChange = function onChange(val) {
    cov_kytgi2cln().f[3]++;
    cov_kytgi2cln().s[15]++;
    setValue(val);
  };
  var initialPreparedPrice = (cov_kytgi2cln().s[16]++, (cov_kytgi2cln().b[2][0]++, priceRaw) && (cov_kytgi2cln().b[2][1]++, isRawPriceValid) ? (cov_kytgi2cln().b[1][0]++, priceRaw) : (cov_kytgi2cln().b[1][1]++, price));
  var value = (cov_kytgi2cln().s[17]++, isCalculationEnabled ? (cov_kytgi2cln().b[3][0]++, Number(inputValue)) : (cov_kytgi2cln().b[3][1]++, Number(initialPreparedPrice)));
  var isPi4 = (cov_kytgi2cln().s[18]++, installmentsCount === 4);
  cov_kytgi2cln().s[19]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopupLearnMoreBackgroundHeader, {
    onClose: onClose,
    title: t('paid_plans.get_more_time_to_pay', {
      installmentsCount: installmentsCount
    }),
    subtitle: t('paid_plans.split_your_purchase', {
      installmentsCount: installmentsCount
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container, _defineProperty({}, styles.inputContainer, isCalculationEnabled))
  }, (cov_kytgi2cln().b[4][0]++, isCalculationEnabled) && (cov_kytgi2cln().b[4][1]++, /*#__PURE__*/React.createElement(InstallmentsInput, {
    id: "long-term-input",
    value: inputValue,
    onChange: onChange,
    className: styles.input
  })), (cov_kytgi2cln().b[5][0]++, country === 'KSA') && (cov_kytgi2cln().b[5][1]++, /*#__PURE__*/React.createElement(InstallmentItem, {
    title: t('payments_other', {
      installmentsCount: INSTALLMENT_PLANS.three
    }),
    subtitle: t('paid_plans.no_interest_no_fees'),
    paymentsInfo: t('paid_plans.payment_per_period', {
      price: getPriceSplitOf(value, _currency, INSTALLMENT_PLANS.three),
      period: t('period')
    }, {
      currency: function currency() {
        cov_kytgi2cln().f[4]++;
        cov_kytgi2cln().s[20]++;
        return /*#__PURE__*/React.createElement(Currency, {
          currency: _currency
        });
      }
    }),
    list: isCalculationEnabled
  })), /*#__PURE__*/React.createElement(InstallmentItem, {
    title: t('payments_other', {
      installmentsCount: installmentsCount
    }),
    subtitle: (cov_kytgi2cln().b[7][0]++, country === 'KSA') && (cov_kytgi2cln().b[7][1]++, isPi4) ? (cov_kytgi2cln().b[6][0]++, t('no_interest_processing_fee_may_apply')) : (cov_kytgi2cln().b[6][1]++, t('paid_plans.no_interest_no_fees')),
    paymentsInfo: t('paid_plans.payment_per_period', {
      price: pricePart,
      period: t('period')
    }, {
      currency: function currency() {
        cov_kytgi2cln().f[5]++;
        cov_kytgi2cln().s[21]++;
        return /*#__PURE__*/React.createElement(Currency, {
          currency: _currency
        });
      }
    }),
    isGreenSubtitle: country !== 'KSA',
    list: isCalculationEnabled
  })), /*#__PURE__*/React.createElement(PayNextMonthTab, null), /*#__PURE__*/React.createElement(LearnMoreHowItWorks, {
    partnerCharges: partnerCharges
  }), country === 'KSA' ? (cov_kytgi2cln().b[8][0]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('shariah_compliant_payments'),
    description: t('our_payment_options_meet_islamic_finance_standards'),
    icon: "shariat-modern",
    iconClassName: styles.bannerIcon
  })) : (cov_kytgi2cln().b[8][1]++, /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_trusted.trusted_by_milions'),
    description: t('over_20_million_shoppers_pay_with_tabby'),
    icon: "people"
  })), /*#__PURE__*/React.createElement(TrustBanner, {
    title: t('tabby_care.show_safely'),
    description: t('tabby_care.buyer_protection_included'),
    icon: "tabby-care"
  }), (cov_kytgi2cln().b[9][0]++, onContinue) && (cov_kytgi2cln().b[9][1]++, /*#__PURE__*/React.createElement(Button, {
    onClick: onContinue,
    testAttr: "continue-shopping"
  }, t('tabbySplit.continue_shopping'))), /*#__PURE__*/React.createElement(CreditCards, {
    country: country,
    fullWidth: true
  }));
};